import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);

function formatTime (milliseconds) {
  let minutes = Math.round(milliseconds/(60*1000));
  let hours = Math.floor(minutes/60);
  if(hours > 0) minutes = minutes % 60;
  const hoursLabel = hours > 0 ? `${hours}h ` : '';
  const minutesLabel = `${minutes}m`;
  return `${hoursLabel}${minutesLabel}`;
}
function totalTime (milliseconds) {
  let minutes = Math.round(milliseconds/60*1000);
  return minutes;
}

export default {
  changeColorHead: (state, color) => (state.configuration.headerColor = color),
  changeColorMenu: (state, color) => (state.configuration.menuColor = color),
  changeLogo: (state, image) => {
    state.configuration.logo = image;
  },
  addNewUser: (state, user) => {
    state.newuser = user;
  },
  currentUser: (state, user) => {
    state.userId = user.id || user._id;
    state.currentUser = user;
  },
  addUsers: (state, users) => {
    state.users = users;
  },
  addBuilding: (state, edificio) => {
    state.buildings.buildingsList.push(edificio);
  },
  addBuildings: (state, objList) => {
    state.buildings.buildingsList = objList;
  },
  changeBuildingState: (state, obj) => {
    state.buildings.buildingsList[obj.i].estado = obj.estado;
  },
  addTask: (state, tarea) => {
    state.currentCP.tasks.push(tarea);
  },
  addCheckPointTask: (state, { obj, i }) => {
    state.buildings.controlPointList[i].tasks.push(obj);
  },
  addTasks: (state, arr) => {
    state.currentCP.tasks = arr;
  },
  addTaskType: (state, obj) => {
    state.currentCP.tasks[obj.i].type = obj.type;
    state.currentCP.tasks[obj.i].labeltype = obj.labeltype;
  },
  addTaskName: (state, obj) => {
    state.currentCP.tasks[obj.i].name = obj.name;
  },
  addTaskRangeMin: (state, obj) => {
    state.currentCP.tasks[obj.i].minRange = Number(obj.range);
  },
  addTaskRangeMax: (state, obj) => {
    state.currentCP.tasks[obj.i].maxRange = Number(obj.range);
  },
  addControlPoint: (state, controlPoint) => {
    state.buildings.controlPointList.push(controlPoint);
  },
  addControlPoints: (state, obj) => {
    state.buildings.controlPointList = obj;
  },
  addNewControlPoint: (state, controlPoint) => {
    state.newControlPoint = controlPoint;
  },
  resetNewControlPoint: state => {
    state.newControlPoint = {};
  },
  addNewControlPointTask: (state, task) => {
    state.newControlPoint.tasks = task;
  },
  changeModal: (state, tipo) => {
    if (tipo == "edificio") {
      state.modalEdificio = !state.modalEdificio;
    }
    if (tipo == "tareas") {
      state.modalTareas = !state.modalTareas;
    }
    if (tipo == "delete") {
      state.modalDelete = !state.modalDelete;
    }
    if (tipo == "deleteOnly") {
      state.modalDelete = false;
    }
  },
  addImageTemp: (state, image) => {
    state.imageTemp.preview = image.preview;
    state.imageTemp.file = image.file;
  },
  addImageTempPre: (state, image) => {
    state.imageTemp.preview = image;
  },
  resetImageTemp: state => {
    state.imageTemp = {};
  },
  addCompanyData: (state, data) => {
    state.company = data;
  },
  resetCompany: state => {
    state.company = {};
  },
  changeConectionState: (state, payload) => {
    state.conectionState = payload;
  },
  resetConectionState: state => {
    state.conectionState = false;
  },
  changeColors: (state, obj) => {
    state.configuration.headerColor = obj.hmenuColor;
    state.configuration.menuColor = obj.hbodyColor;
  },
  setCurrentCP: (state, obj) => {
    state.currentCP = obj;
  },
  changeCurrentCP: (state, obj) => {
    state.currentCP.name = obj.name;
    state.currentCP.location = obj.location;
    state.currentCP.description = obj.description;
    state.currentCP.image = obj.image;
    state.currentCP.typificationId = obj.typificationId;
  },
  resetCurrentCP: state => {
    state.currentCP = {};
  },
  addCP_id: (state, id) => {
    state.cp_id = id;
  },
  addListBuild: (state, arr) => {
    state.localListBuild = arr;
  },
  addAlternativa: (state, { id, val }) => {
    state.currentCP.tasks.find(task => task.id == id).alternatives.push(val);
  },
  udAlternativa: (state, { val, id, index }) => {
    state.currentCP.tasks.find(task => task.id == id).alternatives[
      index
    ].value = val;
  },
  delAlternativa: (state, { id, index }) => {
    state.currentCP.tasks
      .find(task => task.id == id)
      .alternatives.splice(index, 1);
  },
  resetTasks: state => {
    state.buildings.taskList = [];
  },
  resetCP_id: state => {
    state.cp_id = undefined;
    Vue.localStorage.remove("cp_id");
  },
  setCompanyId: (state, id) => {
    state.companyId = id;
  },
  setDashBuildings: (state, arr) => {
    state.dashBuildings = arr;
  },
  viewSidebar: state => {
    state.showSidebar = !state.showSidebar;
  },
  setDashInfo: (state, obj) => {
    state.dashinfo = obj;
  },
  setReportInfo: (state, obj) => {
    state.reportInfo = obj;
  },
  setColorChildren: (state, str) => {
    switch (str) {
      case "dashboard":
        state.colorDash = true;
        break;
      case "edificios":
        state.colorEdificios = true;
        break;
      case "diseno":
        state.colorDiseño = true;
        break;
      case "listuser":
        state.colorUsers = true;
        break;
      case "statistics":
        state.colorStat = true;
        break;
      case "statisticCheckpointBuildings":
        state.colorStCheckpoint = true;
        break;
      case "statisticsReporters":
        state.colorStRep = true;
        break;
      case "download":
        state.colorDown = true;
        break;
    }
  },
  resetColorChildren: (state, str) => {
    switch (str) {
      case "dashboard":
        state.colorDash = false;
        break;
      case "edificios":
        state.colorEdificios = false;
        break;
      case "diseno":
        state.colorDiseño = false;
        break;
      case "listuser":
        state.colorUsers = false;
        break;
      case "statistics":
        state.colorStat = false;
        break;
      case "statisticCheckpointBuildings":
        state.colorStCheckpoint = false;
        break;
      case "statisticsReporters":
        state.colorStRep = false;
        break;
      case "download":
        state.colorDown = false;
        break;
    }
  },
  resetCurrentUser: state => {
    state.currentUser = {};
  },
  resetRole: state => {
    state.isMaster = false;
  },
  setRoleMaster: state => {
    state.isMaster = true;
    window.localStorage.setItem("isMaster", true)
  },
  setRoleMasterEdit: state => state.canEdit = true,
  updateCPImage: (state, payload) => {
    state.currentCP.image = payload;
  },
  listStatCP: (state, payload) => {
    state.statCPs = payload;
  },
  updateCurrentCPStats: (state, payload) => {
    state.currentCPStat = payload;
  },
  createChartOptions: (state, payload) => {
    let data = state.statCPs;
    let series = [];
    var aux = [1, 2, 3, 4];
    for (let n of aux) {
      switch (n) {
        case 1:
          let obj = {
            name: "Bien",
            data: data.map(c => {
              return c.welltaks;
            })
          };
          series.push(obj);
          break;
        case 2:
          let obj2 = {
            name: "Pendiente",
            data: data.map(c => {
              return c.pendingtaks;
            })
          };
          series.push(obj2);
          break;
        case 3:
          let obj3 = {
            name: "Mal",
            data: data.map(c => {
              return c.badtaks;
            })
          };
          series.push(obj3);
          break;
        case 4:
          let obj4 = {
            name: "StandBy",
            data: data.map(c => {
              return c.standbytaks;
            })
          };
          series.push(obj4);
      }
    }
    state.statisticsCheckpointsChart = {
      chart: {
        // height: 350 ||series[0].data.length * 30,
        height: Math.max(300, series[0].data.length * 30),
        // width: 990,
        type: "bar",
        stacked: true,
        stackType: "100%",
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true
          }
        },
        zoom: {
          enabled: true
        }
      },
      responsive: [
        {
          breakpoint: 770,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0
            },
            chart: {
              width: 700
            }
          }
        },
        {
          breakpoint: 992,
          options: {
            chart: {
              width: 800
            }
          }
        },
        {
          breakpoint: 1200,
          options: {
            chart: {
              width: 990
            }
          }
        },
        {
          breakpoint: 1440,
          options: {
            chart: {
              width: 1100
            }
          }
        }
      ],
      stroke: {
        width: 1,
        colors: ["#fff"]
      },
      title: {
        text:
          "Estadísticas del día : Tareas(PENDIENTE,BIEN,MAL, STANDBY) / punto de control"
      },
      colors: ["#2ecc71", "#f5a623", "#ff5a5f", "#808080"],
      legend: {
        position: "top",
        horizontalAlign: "left",
        offsetX: 400,
        useSeriesColors: true
      },
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      series: [],
      xaxis: {
        type: "text",
        categories: payload.checkpoints.map(c => {
          return c.name;
        })
      },
      fill: {
        opacity: 1,
        colors: ["#2ecc71", "#f5a623", "#ff5a5f", "#808080"]
      },
      tooltip: {}
    };
  },
  optionByCheckpointChart: (state, payload) => {
    let data = state.currentCPStat.listrep.map(r => {
      return r.report;
    });
    let series = [];
    var aux = [1, 2, 3, 4];
    for (let n of aux) {
      switch (n) {
        case 1:
          let obj = {
            name: "Bien",
            data: data.map(c => {
              let sum = 0;
              for (let d of c) {
                if (d.reportstatus == "well") {
                  sum = +d.count;
                } else {
                  sum;
                }
              }
              return sum;
            })
          };
          series.push(obj);
          break;
        case 2:
          let obj2 = {
            name: "Pendiente",
            data: data.map(c => {
              let sum = 0;
              for (let d of c) {
                if (d.reportstatus == "pending") {
                  return (sum = +d.count);
                } else {
                  return sum;
                }
              }
            })
          };
          series.push(obj2);
          break;
        case 3:
          let obj3 = {
            name: "Mal",
            data: data.map(c => {
              let sum = 0;
              for (let d of c) {
                if (d.reportstatus == "bad") {
                  return (sum = +d.count);
                } else {
                  return sum;
                }
              }
            })
          };
          series.push(obj3);
          break;
        case 4:
          let obj4 = {
            name: "StandBy",
            data: data.map(c => {
              let sum = 0;
              for (let d of c) {
                if (d.reportstatus == "standby") {
                  return (sum = +d.count);
                } else {
                  return sum;
                }
              }
            })
          };
          series.push(obj4);
      }
    }

    let datachart = {
      chart: {
        height: 600,
        // width: 990,
        type: "bar",
        stacked: true,
        toolbar: {
          show: true
        },
        zoom: {
          enabled: true
        }
      },
      responsive: [
        {
          breakpoint: 770,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0
            },
            chart: {
              width: 700
            }
          }
        },
        {
          breakpoint: 992,
          options: {
            chart: {
              width: 800
            }
          }
        },
        {
          breakpoint: 1200,
          options: {
            chart: {
              width: 990
            }
          }
        },
        {
          breakpoint: 1440,
          options: {
            chart: {
              width: 1100
            }
          }
        }
      ],
      title: {
        text:
          "Información histórica globales(de todos los edificios) : Tareas(PENDIENTE,BIEN,MAL,STANDBY)/fecha del punto de conntrol"
      },
      colors: ["#2ecc71", "#f5a623", "#ff5a5f", "#808080"],
      legend: {
        useSeriesColors: true
      },
      plotOptions: {
        bar: {
          horizontal: false
        }
      },
      series: series || [],
      xaxis: {
        type: "text",
        categories: payload.listrep.map(c => {
          return c.date;
        })
      },
      fill: {
        opacity: 1,
        colors: ["#2ecc71", "#f5a623", "#ff5a5f", "#808080"]
      }
    };
    state.currentCheckpointChart = datachart;
  },
  updateReportuserStats: (state, payload) => {
    state.userStat = payload;
    for (var item of payload.graph.series) {
      item.data.unshift(0);
    }
    payload.graph.xaxis.unshift("inicio");
    let datachart = {
      chart: {
        height: 550,
        // width: 990,
        type: "line",
        shadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 1
        },
        zoom: {
          enabled: false
        }
      },
      responsive: [
        {
          breakpoint: 770,
          options: {
            chart: {
              width: 700
            }
          }
        },
        {
          breakpoint: 992,
          options: {
            chart: {
              width: 800
            }
          }
        },
        {
          breakpoint: 1200,
          options: {
            chart: {
              width: 990
            }
          }
        },
        {
          breakpoint: 1440,
          options: {
            chart: {
              width: 1100
            }
          }
        }
      ],
      // colors: ["#77B6EA", "#545454", "#22CD65", "#44FD31"],
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: "smooth"
      },
      series: payload.graph.series || [],
      title: {
        text: "Estadísticas: Reportadores",
        align: "left"
      },
      grid: {
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5
        }
      },
      markers: {
        style: "inverted",
        size: 6
      },
      xaxis: {
        categories: payload.graph.xaxis || [],
        title: {
          text: "Fechas"
        }
      },
      yaxis: {
        title: {
          text: "Cantidad de tareas reportadas"
        },
        min: 1,
        max: 40
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5
      }
    };
    state.statisticsUsersChart = datachart;
    state.statisticsUsersTable = payload.graph.table.filter(row => Boolean(row.id)).map(row => {
      const listDates = payload.data.filter(d => d.user.id === row.id).map(d => {
        const listOrdered = d.listdates.sort((a, b) => {
          return new Date(a) - new Date(b);
        }) 
        return {
          totalTime: (new Date(listOrdered[listOrdered.length-1]) - new Date(listOrdered[0]))
        }
      })
      return {
        ...row, promTime: formatTime(listDates.reduce((acc, dat) => acc + dat.totalTime, 0)/listDates.length)
      }
    });
  },
  drawCompareUserStats(state, list) {
    var payload = state.userStat;
    var customxaxis = [];
    if (payload.data.length == 0) {
      var datacharthour = undefined;
    } else {
      for (var i of payload.graph.xaxis) {
        for (var u of list) {
          customxaxis.push(`${i}(${u.email})`);
        }
      }
      customxaxis = payload.graph.xaxis;

      var newSeries = {};
      for (var u of list) {
        newSeries[u.email] = {
          name: u.email,
          type: "line",
          data: Array(customxaxis.length).fill(0)
        };
      }

      var comparador = Array(customxaxis.length).fill(0);

      for (var i of payload.data) {
        for (var u of list) {
          if (u.id == i.user.id) {
            var iOf = customxaxis.indexOf(`${i.date}`);
            i.listdates.sort((a, b) => {
              return new Date(a) - new Date(b);
            });
            var initDate = i.listdates[0];
            var endDate = i.listdates[i.listdates.length - 1];
            newSeries[u.email].data[iOf] = ((new Date(endDate).getTime() -
              new Date(initDate).getTime()) /
              (1000 * 60)).toFixed(0);
            comparador[iOf] = newSeries[u.email].data[iOf];
          }
        }
      }
      var series = Object.values(newSeries);
      let maxArr = series.map(i => {
        let max = 0;
        for (let d of i.data) {
          if (max < Number(d)) {
            max = Number(d);
          }
        }
        return max;
      });
      let max = Math.max(...maxArr) * 1.08;

      var datacharthour = {
        chart: {
          height: 500,
          type: "line"
          // width: 1200
        },
        responsive: [
          {
            breakpoint: 770,
            options: {
              chart: {
                width: 700
              }
            }
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                width: 800
              }
            }
          },
          {
            breakpoint: 1100,
            options: {
              chart: {
                width: 850
              }
            }
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                width: 990
              }
            }
          },
          {
            breakpoint: 1440,
            options: {
              chart: {
                width: 1100
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: val => {
              let hours = Math.floor(val / 60);
              let min = Math.floor(val % 60);
              let result = hours > 0 ? `${hours} h ${min} min` : `${min} min`;
              return result;
            },
            title: {
              formatter: seriesName => seriesName
            }
          }
        },
        series: [
          ...series
          //   ,{
          //   name: 'linea',
          //   type:'comparador',
          //   data: comparador
          // }
        ],
        legend: {
          show: false
        },
        title: {
          text: "Historial de Usuario"
        },
        xaxis: {
          categories: customxaxis || [],
          title: {
            text: "Fechas"
          },
          labels: {
            formatter: val => {
              let arr = val.split("-");
              let month = "";
              switch (Number(arr[1])) {
                case 1:
                  month = "Ene";
                  break;
                case 2:
                  month = "Feb";
                  break;
                case 3:
                  month = "Mar";
                  break;
                case 4:
                  month = "Abr";
                  break;
                case 5:
                  month = "May";
                  break;
                case 6:
                  month = "Jun";
                  break;
                case 7:
                  month = "Jul";
                  break;
                case 8:
                  month = "Ago";
                  break;
                case 9:
                  month = "Set";
                  break;
                case 10:
                  month = "Oct";
                  break;
                case 11:
                  month = "Nov";
                  break;
                case 12:
                  month = "Dic";
                  break;
              }
              return `${arr[0]} ${month}`;
            }
          }
        },
        yaxis: [
          {
            title: {
              text: "Duracion (en minutos)"
            },
            min: 0,
            max: max
          }
          // ,
          // {
          //   opposite: false,
          //   title: {
          //     text: 'Numero de puntos de control'
          //   }
          // }
        ]
      };
    }
    state.statisticsUsersChartHour = datacharthour;
  },
  buildBuildingsStat(state, payload) {
    state.buildingsChartPayload = payload;

    var titleP = "";
    if (payload.checkpoint) {
      if (payload.building) {
        titleP = `${payload.checkpoint.name} -  ${payload.building.name}`;
      } else {
        titleP = `${payload.checkpoint.name}`;
      }
      state.buildingsStatTable = payload.data ? payload.data.reverse() : [];
    }
    var regDate = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
    let datachart;
    if (payload.graph.xaxis.length == 0) {
      datachart = undefined;
    } else {
      datachart = {
        chart: {
          height: 600,
          type: "bar",
          stacked: true,
          stackType: "100%",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
            // autoSelected: 'zoom'
          },
          zoom: {
            enabled: true
          }
        },
        title: {
          text: `Historico: ${titleP}`
        },
        plotOptions: {
          bar: {
            columnWidth: "100%"
          }
        },
        responsive: [
          {
            breakpoint: 770,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              },
              chart: {
                width: 700
              }
            }
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                width: 800
              }
            }
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                width: 990
              }
            }
          },
          {
            breakpoint: 1440,
            options: {
              chart: {
                width: 1100
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        dataLabels: {
          formatter: function (val) {
            if (val % 1 == 0) {
              return `${val}%`;
            } else {
              return `${val.toFixed(1)}%`;
            }
          }
        },
        series: payload.graph.series || [],
        xaxis: {
          // type: 'datetime',
          categories: payload.graph.xaxis || [],
          labels: {
            show: true,
            rotate: -45,
            offsetX: payload.buildings ? 10 : 0,
            formatter: val => {
              if (regDate.exec(val)) {
                let arr = val.split("-");
                let month = "";
                switch (Number(arr[1])) {
                  case 1:
                    month = "Ene";
                    break;
                  case 2:
                    month = "Feb";
                    break;
                  case 3:
                    month = "Mar";
                    break;
                  case 4:
                    month = "Abr";
                    break;
                  case 5:
                    month = "May";
                    break;
                  case 6:
                    month = "Jun";
                    break;
                  case 7:
                    month = "Jul";
                    break;
                  case 8:
                    month = "Ago";
                    break;
                  case 9:
                    month = "Set";
                    break;
                  case 10:
                    month = "Oct";
                    break;
                  case 11:
                    month = "Nov";
                    break;
                  case 12:
                    month = "Dic";
                    break;
                }
                return `${arr[0]} ${month}`;
              } else {
                if (val.length >= 19) {
                  let aux = val.slice(0, 17);
                  return `${aux}`;
                }
                return `${val}`;
              }
            }
          }
        },
        colors: ["#ff5a5f", "#2ecc71", "#f5a623", "#808080"],
        fill: {
          opacity: 1,
          colors: ["#ff5a5f", "#2ecc71", "#f5a623", "#808080"]
        },
        tooltip: {
          x: {
            formatter: val => {
              return val;
            }
          }
        }
      };
    }
    state.buildingsChart = datachart;
    if (payload.buildings) {
      for (var i of payload.buildings) {
        i.checked = true;
      }
    }
    state.buildingsStatList = payload.buildings;
    // console.log(datachart);
  },
  // drawBuildingsStatComp: (state, list) => {
  //   var titleP = ""
  //   var payload = state.buildingsChartPayload
  //   if (payload.checkpoint) {
  //     if (payload.building) {
  //       titleP = `${payload.checkpoint.name} -  ${payload.building.name}`
  //     } else {
  //       titleP = `${payload.checkpoint.name}`
  //     }
  //   }
  //   let index = []
  //   for (var i of list) {
  //     if (!i.checked) {
  //       index.push(list.indexOf(i))
  //     }
  //   }
  //   var newSeries = payload.graph.series.map(s => {
  //     var obj = {
  //       name: s.name
  //     }
  //     obj.data = []
  //     for (var i in s.data) {
  //       if (i != index[i]) {
  //         obj.data.push(s.data[i])
  //       }
  //     }
  //     return obj
  //   })
  //   console.log(payload.graph.xaxis.filter(x => !index.includes(payload.graph.xaxis.indexOf(x))));

  //   var newxaxis = payload.graph.xaxis.filter(x => !index.includes(payload.graph.xaxis.indexOf(x)))

  //   let datachart = {
  //     chart: {
  //       height: 350,
  //       // width: 990,
  //       type: 'bar',
  //       stacked: true,
  //       stackType: '100%',
  //       toolbar: {
  //         show: true
  //       },
  //       zoom: {
  //         enabled: true
  //       }
  //     },
  //     title: {
  //       text: `Historico: ${titleP}`
  //     },
  //     responsive: [{
  //       breakpoint: 770,
  //       options: {
  //         legend: {
  //           position: 'bottom',
  //           offsetX: -10,
  //           offsetY: 0
  //         },
  //         chart: {
  //           width: 700
  //         }
  //       }
  //     }, {
  //       breakpoint: 992,
  //       options: {
  //         chart: {
  //           width: 800
  //         }
  //       }
  //     }, {
  //       breakpoint: 1200,
  //       options: {
  //         chart: {
  //           width: 990
  //         }
  //       }
  //     }],
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //       },
  //     },
  //     series: newSeries || [],
  //     xaxis: {
  //       // type: 'datetime',
  //       categories: payload.graph.xaxis || []
  //     },
  //     colors: ['#ff5a5f', '#2ecc71', '#f5a623'],
  //     fill: {
  //       opacity: 1,
  //       colors: ['#ff5a5f', '#2ecc71', '#f5a623']
  //     }
  //   }
  //   state.buildingsChart = datachart;
  // },
  updateChartByCPEdi: (state, payload) => {
    var listrep = state.currentCPStat.listrep;
    var listrep2 = state.currentCPStat.listrep2;
    var xaxisMap = {};
    var xaxis = [];
    var series = [];
    for (var u of listrep) {
      //Mapeo eje X
      if (!xaxisMap[u.date]) {
        xaxisMap[u.date] = true;
        xaxis.push(u.date);
      }
    }

    if (payload.edArr.length) {
      let count = 0;
      let series = [];
      var customxaxis = [];
      for (var i of xaxis) {
        for (var b of payload.edArr) {
          customxaxis.push(`${i}(${b.name})`);
        }
      }
      var statusSeries = {
        bad: {
          name: "MAL",
          data: Array(customxaxis.length).fill(0)
        },
        well: {
          name: "BIEN",
          data: Array(customxaxis.length).fill(0)
        },
        pending: {
          name: "PENDIENTE",
          data: Array(customxaxis.length).fill(0)
        }
      };
      for (var b of payload.edArr) {
        for (var c of listrep2) {
          if (c.building == String(b.id)) {
            for (var s of c.report) {
              var iOf = customxaxis.indexOf(`${s.formatDate}(${b.name})`);
              statusSeries[s.reportstatus].data[iOf] = s.count;
            }
          }
        }
      }
      series = Object.values(statusSeries);
      let datachart = {
        chart: {
          height: 350,
          type: "bar",
          stacked: true,
          stackType: "100%",
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        responsive: [
          {
            breakpoint: 770,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              },
              chart: {
                width: 700
              }
            }
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                width: 800
              }
            }
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                width: 990
              }
            }
          },
          {
            breakpoint: 1440,
            options: {
              chart: {
                width: 1100
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        series: series,
        xaxis: {
          // type: 'datetime',
          categories: customxaxis
          //  ['01/01/2011 GMT', '01/02/2011 GMT', '01/03/2011 GMT', '01/04/2011 GMT', '01/05/2011 GMT', '01/06/2011 GMT'],
        },
        fill: {
          opacity: 1
        }
      };
      state.currentCheckpointChartEdi = datachart;
    }
  },
  drawReporterHistoric: (state, payload) => {
    var titleP = "";

    if (payload.user) {
      titleP = `${payload.user.firstName} ${payload.user.lastName}`;
    }
    let max = Math.max(...payload.graph.series[0].data);
    // console.log(payload.graph.series);
    if (payload.data.length == 0) {
      state.currentReporterChart = undefined;
    } else {
      state.currentReporterChart = {
        chart: {
          height: 350,
          type: "line",
          stacked: false
        },
        responsive: [
          {
            breakpoint: 770,
            options: {
              chart: {
                width: 700
              }
            }
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                width: 800
              }
            }
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                width: 990
              }
            }
          },
          {
            breakpoint: 1440,
            options: {
              chart: {
                width: 1100
              }
            }
          }
        ],
        dataLabels: {
          enabled: false
        },
        series: payload.graph.series,
        stroke: {
          width: [1, 1, 4]
        },
        title: {
          text: `Reporte Histórico: ${titleP}`,
          align: "left",
          offsetX: 110
        },
        xaxis: {
          categories: payload.graph.xaxis,
          // type: 'datetime'
          labels: {
            formatter: val => {
              let arr = val.split("-");
              let month = "";
              switch (Number(arr[1])) {
                case 1:
                  month = "Ene";
                  break;
                case 2:
                  month = "Feb";
                  break;
                case 3:
                  month = "Mar";
                  break;
                case 4:
                  month = "Abr";
                  break;
                case 5:
                  month = "May";
                  break;
                case 6:
                  month = "Jun";
                  break;
                case 7:
                  month = "Jul";
                  break;
                case 8:
                  month = "Ago";
                  break;
                case 9:
                  month = "Set";
                  break;
                case 10:
                  month = "Oct";
                  break;
                case 11:
                  month = "Nov";
                  break;
                case 12:
                  month = "Dic";
                  break;
              }
              return `${arr[0]} ${month}`;
            }
          }
        },
        yaxis: [
          {
            opposite: true,
            seriesName: "Duración",
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: "#386EFF"
            },
            labels: {
              style: {
                color: "#386EFF"
              },
              formatter: function (val) {
                return `${val} min`;
              }
            },
            title: {
              text: "Tiempo entre el primer y ultimo reporte subido"
            }
          },
          {
            seriesName: "Tareas",
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: "#2CF9A8"
            },
            labels: {
              style: {
                color: "#2CF9A8"
              },
              formatter: val => {
                return `${val}`;
              }
            },
            title: {
              text: "Número de tareas realizadas por el usuario"
            }
          }
        ],
        tooltip: {
          // fixed: {
          //   enabled: true,
          //   position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
          //   offsetY: 30,
          //   offsetX: 60
          // },
          shared: true,
          enabled: true,
          y: {
            // title:{
            //   formatter: (val) => {
            //     return val == 'Duración' ? 'Duración (min)' : 'Tareas'
            //   }
            // },
            formatter: val => {
              let result;
              if (val % 1 != 0) {
                let aux = val % 1 >= 0.5 ? Math.ceil(val) : Math.floor(val);
                let hours = Math.floor(aux / 60);
                let min = aux % 60;
                result = hours > 0 ? `${hours} h ${min} min` : `${min} min`;
              } else {
                result = `${val} tareas`;
              }

              return result;
            }
          }
        },
        legend: {
          horizontalAlign: "left",
          offsetX: 40
        }
      };
    }
    state.currentReporterList = payload.data.map(dat => {
      return {
        ...dat, diffTime: formatTime(new Date(dat.endDate) - new Date(dat.initDate))
      }
    });
  },
  activeLoader: state => {
    state.isLoader = true;
  },
  deactiveLoader: state => {
    state.isLoader = false;
  },
  setBusinessList: (state, payload) => {
    state.businessList = payload;
  },
  setBusinessCurrentView: (state, payload) => {
    state.businessCurrentView = JSON.parse(JSON.stringify(payload));
  },
  setApiKey: (state, payload) => {
    state.apiKey = payload;
  },
  addOwners: (state, payload) => {
    state.usersOwners = new Array(...payload);
  },
  addOwnerDetail: (state, payload) => {
    state.onwerDetail = JSON.parse(JSON.stringify(payload));
  },
  setErrorMessage: (state, payload) => {
    state.errorMessage = payload;
  },
  setBusinessImage: (state, payload) => {
    state.businessImage = payload;
  },
  setSubdomain: (state, payload) => {
    state.subdomain = payload;
  },
  setNamespace: (state, payload) => {
    state.namespace = payload;
  },
  setCheckpointType: (state, payload) => {
    state.checkpointTypes = payload
  }
};



// WEBPACK FOOTER //
// ./src/vuex/mutations/index.js